import { VmsService } from './../../services/vms.service';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbDate, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { DateService } from 'src/app/services/date.service';
import { resolveMx } from 'dns';
import { FormControl, FormGroup } from '@angular/forms';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';

@Component({
  standalone: false,
  selector: 'app-individual-invite',
  templateUrl: './individual-invite.component.html',
  styleUrls: ['./individual-invite.component.scss'],
})
export class IndividualInviteComponent implements OnInit {
  name: boolean;
  fieldErrors: any[];
  guestName: boolean;
  guestMobile: boolean;
  guestEmail: boolean;
  vehicleNumber: any;
  vehicleType: any;
  floor: any;
  buildingName: any;
  formatDate: any;
  buildingTitle: string = '';
  fullname: string;
  mobileNumber: any;
  emailId: any;
  vehicleTypeList: any = [];
  buildingProperty: any = [];
  floorList: any = [];
  floorTitle: any;
  guestList: {
    srNo?: number;
    fullName: string;
    mobile: any;
    email: string;
    companyName: string;
    vehicleTypeId: string;
    vehicleType?: string;
    vehicleNo: any;
  }[] = [
      {
        srNo: 1,
        fullName: '',
        mobile: '',
        email: '',
        companyName: '',
        vehicleTypeId: '',
        vehicleType: '',
        vehicleNo: '',
      },
    ];
  propertyType: any;
  myCompanyData: any;
  data: any;
  fullNameList: any;
  floorCount: any;
  buildingId: any;
  meetingPurposeData: any;
  meetingPurpose: any;
  tempMeetingPurposeData: any;
  remarks: string = '';
  startTimePlaceholder: string = '';
  endTimePlaceholder: string = '';
  meridian: boolean = true;
  startTime = { hour: 1, minute: 0 };
  endTime = { hour: 1, minute: 0 };
  amorpm: boolean = false;
  amorpm1: boolean = false;
  mdate: any;
  mend: any;
  selectedDate: string;
  t0600Vmsguests: any[] = [];
  userId: any;
  errorText: string = '';
  error = [];
  errDate: any;
  errTime: any;
  errName: any;
  errfloor: any;
  showError: boolean = false;
  id: any;
  loadScreen: boolean = false;

  constructor(
    private router: Router,
    private dateSrv: DateService,
    public datepipe: DatePipe,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private apiService: VmsService,
    private activatedRoute: ActivatedRoute
  ) {
    const current = new Date();
    ngbDatepickerConfig.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };
    //ngbDatepickerConfig.maxDate = { year: 2099, month: 12, day: 31 };
    ngbDatepickerConfig.outsideDays = 'hidden';
  }

  Form = new FormGroup({
    fullname: new FormControl(''),
    lastName: new FormControl(''),
  });

  ngOnInit(): void {
    this.getVehicleType();
    this.getMeetingPurpose();
    this.activatedRoute.queryParams.subscribe((res) => {
      this.id = res.id ? res.id : null;
    });
    if (this.id !== null) {
      this.loadData(this.id);
    } else {
      this.getMyCompanyDetails('645');
    }
    const jsDate = new Date();
  }

  loadData(id) {
    const data = {
      InvitationID: id,
    };
    this.apiService.getInvitationDetail(data).subscribe((res) => {
      console.log(res);
      this.getMyCompanyDetails(res?.parkUserId);
      this.guestList = res?.t0600Vmsguests;
      this.setBuildingName(res?.buildingId, res?.buildingName);
      this.setFloor(res?.floor)
      res?.t0600Vmsguests.forEach((element, index) => {
        this.guestList[index].vehicleNo = element.t0600GuestVehicles[0].vehicleNo
        this.setVehicleType('name', element.t0600GuestVehicles[0].vehicleType, index)
      });
    });
  }

  public updateSelectedDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);

    this.selectedDate = this.convertFormat(date.year, date.month, date.day);
    this.formatDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    this.formatDate =
      this.formatDate.split(' ')[0] +
      ' ' +
      this.formatDate.split(' ')[1] +
      ', ' +
      this.formatDate.split(' ')[2];

    console.log(this.formatDate);
  }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  concatDateTime(type) {
    if (type == 'mstart') {
      return (this.mdate = this.selectedDate.concat(
        ' ' + this.startTimePlaceholder
      ));
    } else {
      return (this.mend = this.selectedDate.concat(' ' + '07:00 PM'));
    }
  }

  toggleAmPmSelection(value: boolean) {
    this.amorpm = value;
    // this.onTimeChange(this.normalizeTime);
  }

  toggleAmPmSelection1(value: boolean) {
    this.amorpm1 = value;
  }

  toggleMeridian() {
    this.meridian = !this.meridian;
  }

  onTimeChange(e) {
    console.log(e, this.amorpm);
    if (e.hour >= 0 && e.hour <= 11) this.amorpm = false;
    else this.amorpm = true;
    this.startTimePlaceholder =
      ('0' + (e.hour > 12 ? e.hour - 12 : e.hour)).slice(-2) +
      ':' +
      ('0' + e.minute).slice(-2) +
      ' ' +
      (this.amorpm ? 'PM' : 'AM');
    console.log('time', this.startTimePlaceholder);
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }
  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  navigate() {
    this.router.navigate(['/vms/bulk-invite']);
  }

  cancel() {
    this.router.navigate(['/vms/individual-invite']);
  }

  addGuest() {
    var data = {
      srNo: this.guestList.length,
      fullName: '',
      mobile: '',
      email: '',
      companyName: '',
      vehicleTypeId: '',
      vehicleNo: '',
    };
    this.guestList.push(data);
  }

  removeGuest(x) {
    this.guestList.forEach((item, index) => {
      if (item.srNo == x) {
        this.guestList.splice(index, 1);
      }
    });
  }

  getMyCompanyDetails(id) {
    const ParkId = localStorage.getItem('parkTenantId')
    console.log(ParkId)
    this.apiService
      .getMyCompanyDetails(ParkId)
      .subscribe((response: any) => {
        // if (response?.data) {
        console.log(response)
        this.myCompanyData = response?.data?.employees;
        this.data = this.myCompanyData.filter((el) => el.userId == id);
        console.log(this.data);
        // this.setFullName(this.data)
        this.fullname = this.data[0].name;
        this.getHostDetail(this.data[0].userId);
        this.loadScreen = true
        // }
      });
  }

  setFullName(item) {
    console.log('set full name', item);
    this.fullname = item.name;
    this.getHostDetail(item.userId);
  }

  setBuildingName(itemId, itemName) {

    this.buildingTitle = itemName;
    this.buildingId = itemId;
  }

  setFloor(item) {
    if (item == null) this.floorTitle = 1
    else this.floorTitle = item;

  }

  setVehicleType(itemName, itemId, i) {
    this.guestList[i].vehicleType = itemName;
    this.guestList[i].vehicleTypeId = itemId;
  }

  getHostDetail(data) {
    this.floorList = [];
    this.userId = data;
    console.log('host detail', data);
    const param = {
      userId: data,
    };
    this.apiService.getHostDetail(param).subscribe((res) => {
      console.log(res)
      this.mobileNumber = res.data ? res.data.mobile : res.mobile;
      this.emailId = res.data ? res.data.emailId : res.emailId;
      this.buildingProperty = res.data
        ? res.data.userBuilding
        : res.userBuilding;
      this.floorCount = res.data ? res.data.floors : res.floors;
      if (this.floorCount == 0 || this.floorCount == null) {
        this.floorList.push('1');
      }
      for (let i = 1; i < this.floorCount; i++) {
        this.floorList.push(i);
      }
    });
  }

  getVehicleType() {
    this.apiService.getVehicleType().subscribe((res) => {
      this.vehicleTypeList = res;
    });
  }

  getMeetingPurpose() {
    this.apiService.getMeetingPurpose().subscribe((res) => {
      this.meetingPurposeData = res;
      this.tempMeetingPurposeData = this.meetingPurposeData.filter(
        (el) => el.meetingPurpose.trim() == 'Official'
      );
      this.meetingPurpose = this.tempMeetingPurposeData[0].meetingPurposeId;
    });
  }

  invite(val) {

    this.validation(val);
    if (this.showError == true) {
      return;
    }

    this.concatDateTime('mstart');
    this.concatDateTime('mend');

    for (let i = 0; i < this.guestList.length; i++) {
      const guestData = {
        fullName: this.guestList[i].fullName,
        mobile: this.guestList[i].mobile,
        email: this.guestList[i].email,
        companyName: this.guestList[i].companyName,
        t0600GuestVehicles: [
          {
            userTypeId: 3,
            vehicleType: this.guestList[i].vehicleTypeId,
            vehicleNo: this.guestList[i].vehicleNo,
            isActive: true,
          },
        ],
      };
      this.t0600Vmsguests.push(guestData);
    }

    const data = {
      parkUserId: this.userId,
      mstart: this.mdate,
      mend: this.mend,
      buildingId: this.buildingId,
      // floor: this.floorTitle,
      floor: 0,
      meetingPurpose: this.meetingPurpose,
      remarks: this.remarks,
      isActive: true,
      isApproved: true,
      t0600Vmsguests: this.t0600Vmsguests,
      invitationTypeName: 'IndividualInvite',
      companyId: localStorage.getItem('tenantId')
    };
    console.log(data);
    this.apiService.createInvitation(data).subscribe((res) => {
      console.log(res);
      if (res?.isValid)
        this.router.navigate(['/vms/individual-invite/status'], {
          queryParams: { id: res?.data?.invitationID },
        });
    });
  }

  enterName(field) {
    if (field == 'name') {
      this.name = !this.name;
    }
    if (field == 'guestName') {
      this.guestName = !this.guestName;

      // this.guestList.forEach((res, i) => {
      //   if(res.fullName.length!=0){
      //     this.guestName=true
      //   }
      // })
    }
    if (field == 'guestMobile') {
      this.guestMobile = !this.guestMobile;
      // this.guestList.forEach((res, i) => {
      //   if(res.mobile.length!=0){
      //     this.guestMobile=true
      //   }
      // })
    }
    if (field == 'guestEmail') {
      this.guestEmail = !this.guestEmail;
    }
    if (field == 'vehicleNumber') {
      this.vehicleNumber = !this.vehicleNumber;
    }
    if (field == 'vehicleType') {
      this.vehicleType = !this.vehicleType;
    }
    if (field == 'floor') {
      this.floor = !this.floor;
    }
    if (field == 'buildingName') {
      this.buildingName = !this.buildingName;
    }
  }

  validation(validate) {
    this.showError = false;
    this.errDate = validate.form.controls.abt?.status;
    this.errTime = validate.form.controls.time?.status;
    this.errName = validate.form.controls.building?.status;
    this.errfloor = validate.form.controls.flr?.status;

    this.guestList.forEach((res, i) => {
      if (res.fullName == undefined || res.fullName.length == 0) {
        this.error[res.fullName + i] = true;
        this.showError = true;
        this.errorText = '*All fields are mandatory';
      }
      if (res.email == undefined || res.email.length == 0 || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(res.email)) {
        this.error[res.email + i] = true;
        this.showError = true;
        this.errorText = '*All fields are mandatory';
      }
      if (res.mobile == null || res.mobile == undefined || !/^\d{10}$/.test(res.mobile)) {

        this.error[res.mobile + i] = true;
        this.showError = true;
        this.errorText = '*All fields are mandatory';
      }
    });

    if (
      this.errDate == 'INVALID' ||
      this.errTime == 'INVALID' ||
      this.errName == 'INVALID' ||
      this.errfloor == 'INVALID'

    ) {
      this.showError = true;
    }
  }
}
